import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AlmoxarifadosViewModel } from 'models/almoxarifados/AlmoxarifadosViewModel';
import { ComboboxPadrao } from 'models/combobox-padrao/combobox-padrao';
import { AlmoxarifadosServiceV2 } from '@sv2/almoxarifados/almoxarifados-v2.service';
import { ComboboxPadraoComponent } from '../combobox-padrao/combobox-padrao.component';
import { MessageService } from '@services';

@Component({
  selector: 'app-combobox-almoxarifados',
  templateUrl: './combobox-almoxarifados.component.html',
  styleUrls: ['./combobox-almoxarifados.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ComboboxAlmoxarifadosComponent),
      multi: true
    }
  ]
})
export class ComboboxAlmoxarifadosComponent extends ComboboxPadrao<AlmoxarifadosViewModel> implements ControlValueAccessor, OnInit {
  override bindLabel = 'nome';
  @Input() override label = 'Almoxarifado para saída';
  @Input() override required = false;
  @Input() override requiredText = 'O almoxarifado para saída é obrigatório';

  @Input() loading = false;
  @Input() disabled = false;
  @Input() notFoundPlusIcon = false;
  @Input() pencilIcon = false;
  @Input() autofocus = false;
  @Input() startOpen = false;
  @Input() atalho = null;
  @Output() changed = new EventEmitter();
  @Output() override onItemsChange = new EventEmitter();
  @ViewChild('comboboxAlmoxarifados', { static: false }) comboboxAlmoxarifados: ComboboxPadraoComponent<AlmoxarifadosViewModel>;

  constructor(
    service: AlmoxarifadosServiceV2,
    message: MessageService,
  ) {
    super('combobox_almoxarifados', message, service);
  }

  ngOnInit() {
    if (this.autofocus) {
      this.focus();
    }
    if (this.startOpen) {
      this.openSearch();
    }
  }

  writeValue(value: number): void {
    this.selected.setValue(value);
  }

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  handleOnChanged(value: number) {
    this.selected.setValue(value);
    this.changed.emit(value);
    this.onChange(value);
  }

  handleOnAdded(value: number) {
    this.selected.setValue(value);
    this.changed.emit(value);
    this.onChange(value);
  }

  handleOnEdited(value: number) {
    this.selected.setValue(value);
    this.changed.emit(value);
    this.onChange(value);
  }

  focus() {
    setTimeout(() => {
      this.comboboxAlmoxarifados.focus();
    }, 100);
  }

  openSearch() {
    setTimeout(() => {
      this.comboboxAlmoxarifados.openSearch();
    }, 100);
  }

  closeSearch() {
    setTimeout(() => {
      this.comboboxAlmoxarifados.closeSearch();
    }, 100);
  }
}
